<mat-card appearance="outlined">
	<mat-card-title *ngIf="!dialogInfo.dontShowTitle" [innerText]="dialogInfo.title | translate"></mat-card-title>
	<mat-card-content [ngClass]="{'no-title': dialogInfo.dontShowTitle}">
		<span class="row">
			<mat-form-field style="text-align: center">
				<mat-label [innerText]="dialogInfo.label | translate"></mat-label>
				<input (blur)="closeDialog(true)" *ngIf="dialogInfo.type == 'time' && isIos" [(ngModel)]="inputValue" [formControl]="inputCtrl" [type]="dialogInfo.type || 'text'" matInput
				       style="text-align: center"/>
				<input *ngIf="dialogInfo.type == 'time' && !isIos" [(ngModel)]="inputValue" [formControl]="inputCtrl" [type]="dialogInfo.type || 'text'" matInput style="text-align: center"/>
				<input *ngIf="dialogInfo.type == 'number'" [(ngModel)]="inputValue" [formControl]="inputCtrl" [type]="dialogInfo.type || 'number'" matInput style="text-align: center"/>
				<input *ngIf="dialogInfo.type == 'text'" [(ngModel)]="inputValue" [formControl]="inputCtrl" [type]="dialogInfo.type || 'text'" matInput style="text-align: center"/>
			</mat-form-field>
		</span>
		<span *ngIf="validationError | async" [innerText]="((validationError | async) || '') | translate" class="row error"></span>
	</mat-card-content>
	<mat-dialog-actions>
		<button (click)="closeDialog(true)" [innerText]="dialogInfo.confirm | translate" class="confirm" mat-stroked-button></button>
		<button (click)="closeDialog(false)" *ngIf="!dialogInfo.dontShowCancel" [innerText]="dialogInfo.cancel | translate" class="cancel" mat-stroked-button></button>
	</mat-dialog-actions>
</mat-card>
